import { omit } from "lodash-es";
import { useSupabaseCallback } from "../../../server/supabase/hooks";
import { SupabaseEmailMomentService } from "../server/supabase-email-moment-service";
import type { EmailMoment } from "../types";

export function useEmailMomentService(): (email_moment: EmailMoment | null) => Promise<void> {
  return useSupabaseCallback(async ({ supabase }, email_moment: EmailMoment | null) => {
    if (!email_moment) {
      return;
    }
    const { error, data } = await new SupabaseEmailMomentService(supabase).upsert(
      omit(email_moment, "newDesign", "used_merge_fields"),
    );
    if (error || !data) throw new Error(error?.message);
  }, []);
}
